import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/workflow/importer/workflowImporterSelectors';
import WorkflowService from 'src/modules/workflow/workflowService';
import fields from 'src/modules/workflow/importer/workflowImporterFields';
import { i18n } from 'src/i18n';

const workflowImporterActions = importerActions(
  'WORKFLOW_IMPORTER',
  selectors,
  WorkflowService.import,
  fields,
  i18n('entities.workflow.importer.fileName'),
);

export default workflowImporterActions;